export const TOOL_TXT = { answer: "Jawab langsung", end_skill: "Skill diakhiri" };
export const toolLabel = (t) => (t ? TOOL_TXT[t] || t : "—");
export const PRESETS = ["Jalankan tahap 2 alur Tren Kopi", "Buatkan poster promo", "Rangkum dokumen Drive Q3", "Ubah agen tahap 3 ke riset"];
export const SCENARIOS = [{ id: "komik6", label: "Komik 6 panel", messages: [
  { role: "user", content: "Bikinin komik 6 panel tentang kucing yang takut hujan" },
  { role: "assistant", content: "Ringkasan kebutuhan: komik 6 panel, tokoh kucing «Momo» yang takut hujan, gaya kartun hangat, untuk Instagram. Lanjutkan?" },
  { role: "user", content: "Lanjutkan" },
  { role: "assistant", content: "Mau langsung dibuat semua, atau susun bertahap dulu per panel?" },
  { role: "user", content: "Susun bertahap dulu" },
  { role: "assistant", content: "Panel 1: Momo menatap awan gelap — kucing oranye di jendela, ekor mengembang. Cocok?" },
  { role: "user", content: "gass" },
  { role: "assistant", content: "Panel 1 terkunci. Panel 2: Hujan turun, Momo sembunyi di kardus — tetes air di luar, mata Momo membesar." },
  { role: "user", content: "Setuju semua, selesaikan sisanya" },
] }];
export const BATCH_LIMIT = 25;

const c = (label, text, expected_tool, messages) => ({ label, text, expected_tool, ...(messages && { messages }) });
export const SAMPLE_WORKSPACE = [
  c("jalankan", "Jalankan tahap 2 di alur Tren Kopi", "workspace_run"),
  c("lihat hasil", "Tunjukkan hasil tahap 1 alur Tren Kopi", "workspace_show_result"),
  c("setujui", "Oke setujui saja", "workspace_set_status", [{ role: "assistant", content: "Tahap 2 menunggu persetujuan." }, { role: "user", content: "Oke setujui saja" }]),
  c("revisi", "Revisi tahap 2, nadanya terlalu formal", "workspace_set_status"),
  c("tempel file", "Tempel file brief.pdf dari chat ini ke tahap 1", "workspace_update_stage"),
  c("ubah agen", "Ubah agen tahap 3 ke riset", "workspace_update_stage"),
  c("ngobrol", "Halo, apa kabar?", "answer"),
  c("batal", "Batal deh, nggak jadi", "end_skill"),
];
export const SAMPLE_INTAKE = [
  c("poster", "Buatkan poster promo kopi susu", "create_image"),
  c("video", "Bikin video 8 detik untuk reels", "create_video"),
  c("riset", "Riset tren kopi 2026 di Jakarta", "delegate_agent"),
  c("email", "Kirim email ke tim soal rapat besok", "gmail_send"),
  c("agenda", "Apa agenda saya besok?", "calendar_events"),
  c("ngobrol", "Terima kasih ya", "answer"),
];

export const lastUser = (msgs) => [...(msgs || [])].reverse().find((m) => m.role === "user")?.content || "";
export const caseMessages = (k) => (k.messages?.length ? k.messages : [{ role: "user", content: k.text || "" }]);
export const toCase = (k) => ({ ...(k.label && { label: k.label }), ...(k.messages?.length ? { messages: k.messages } : { text: k.text }), ...(k.expected_tool && { expected_tool: k.expected_tool }) });

const q = (v) => (/[",\n]/.test(v) ? `"${String(v).replace(/"/g, '""')}"` : v);
export const toCsv = (cases) => ["label,text,expected_tool", ...cases.map((k) => [k.label || "", k.messages?.length ? lastUser(k.messages) : k.text || "", k.expected_tool || ""].map(q).join(","))].join("\n");

export function parseCsv(src) {
  const rows = []; let row = [], cur = "", inQ = false;
  for (let i = 0; i < src.length; i += 1) {
    const ch = src[i];
    if (inQ) { if (ch === '"' && src[i + 1] === '"') { cur += '"'; i += 1; } else if (ch === '"') inQ = false; else cur += ch; }
    else if (ch === '"') inQ = true;
    else if (ch === ",") { row.push(cur); cur = ""; }
    else if (ch === "\n" || ch === "\r") { if (ch === "\r" && src[i + 1] === "\n") i += 1; row.push(cur); rows.push(row); row = []; cur = ""; }
    else cur += ch;
  }
  if (cur || row.length) { row.push(cur); rows.push(row); }
  const data = rows.filter((r) => r.some((x) => x.trim()));
  if (data[0] && data[0][0].trim().toLowerCase() === "label" && (data[0][1] || "").trim().toLowerCase() === "text") data.shift();
  return data.map(([label = "", text = "", expected_tool = ""]) => ({ label: label.trim(), text: text.trim(), expected_tool: expected_tool.trim() })).filter((k) => k.text);
}

export function parseJsonCases(src) {
  const d = JSON.parse(src); const arr = Array.isArray(d) ? d : d.cases;
  if (!Array.isArray(arr)) throw new Error("Format JSON: array kasus atau {cases: [...]}");
  return arr.map((k) => ({ label: k.label || "", text: k.text || lastUser(k.messages), expected_tool: k.expected_tool || "", ...(k.messages?.length && { messages: k.messages }) })).filter((k) => k.text);
}

export function mergeBatches(parts) {
  if (parts.length === 1) return parts[0];
  const counts = {}; const fromSkill = {};
  parts.forEach((p) => (p.summary.tool_counts || []).forEach((t) => { counts[t.tool] = (counts[t.tool] || 0) + t.count; fromSkill[t.tool] = fromSkill[t.tool] || t.from_skill; }));
  const sum = (k) => parts.reduce((a, p) => a + (p.summary[k] || 0), 0);
  const scored = sum("scored"); const matches = sum("matches");
  const summary = { cases: sum("cases"), errors: sum("errors"), skill_tool_hits: sum("skill_tool_hits"), scored, matches, match_rate: scored ? matches / scored : null, credits: Math.round(sum("credits") * 100) / 100, skill_tools: parts[0].summary.skill_tools,
    tool_counts: Object.entries(counts).sort((a, b) => b[1] - a[1]).map(([tool, count]) => ({ tool, count, from_skill: !!fromSkill[tool] })) };
  return { ...parts[parts.length - 1], summary, cases: parts.flatMap((p) => p.cases) };
}

export const download = (name, text, type) => { const a = document.createElement("a"); a.href = URL.createObjectURL(new Blob([text], { type })); a.download = name; a.click(); setTimeout(() => URL.revokeObjectURL(a.href), 500); };
export const pct = (r) => (r == null ? "—" : `${Math.round(r * 100)}%`);
export const cr = (v) => (v == null ? "—" : Number(v).toLocaleString("id-ID", { maximumFractionDigits: 2 }));
